module.exports = __webpack_public_path__ + "img/upc-positiu-p3005.67772a9e.png";